import React from 'react'
import * as Bs from 'react-bootstrap'
import * as Bsr from 'react-router-bootstrap'
import { RouteHandler } from 'react-router'
import DocumentTitle from 'react-document-title'
import Backdrop from '_/shared/components/backdrop'
import getGravatarUrl from '_/utils/getGravatarUrl'

/**
 * Manage group page
 */
class ManageGroup extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired
  }

  render() {
    const { account } = this.props
    const backdropPhoto = getGravatarUrl(
      account.getIn(['group', 'logoEmail']),
      800
    )

    return (
      <DocumentTitle title="Manage group">
        <Backdrop url={backdropPhoto}>
          <h3>Manage group</h3>
          <Bs.Nav bsStyle="tabs">
            <Bsr.NavItemLink to="group-settings">Settings</Bsr.NavItemLink>
            <Bsr.NavItemLink to="group-members">Members</Bsr.NavItemLink>
          </Bs.Nav>
          <br/>
          <RouteHandler {...this.props} />
        </Backdrop>
      </DocumentTitle>
    )
  }
}

export default ManageGroup



// WEBPACK FOOTER //
// ./modules/shared/pages/account/manageGroup.js